import React, { useState } from "react"
import { Box, Typography, TextField, Button, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Stack } from "@mui/material"

const SmsConfig = () => {
  const [twoFactorStatus, setTwoFactorStatus] = useState("inactive")
  const [msgStatus, setMsgStatus] = useState("active")
  const [twoFactorApiKey, setTwoFactorApiKey] = useState("")
  const [msgTemplateId, setMsgTemplateId] = useState("")
  const [msgAuthKey, setMsgAuthKey] = useState("")

  const handleSave = () => {}

  return (
    <div className="content">
      <Box p={3}>
        <Typography variant="h4" sx={{ mb: 3 }}>
          SMS Configuration
        </Typography>

        <Stack direction="row" spacing={3}>
          <Box border={1} borderRadius={2} p={3}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              2FACTOR SMS
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mb: 2,
                color: "success.main",
                display: "inline-block",
                
              }}
            >
              EX of SMS provider's template: Your OTP is XXXX here, please check.
              <br />
              NB: XXXX will be replaced with the OTP.
            </Typography>

            <FormControl component="fieldset" sx={{ mb: 2 }}>
              <RadioGroup row value={twoFactorStatus} onChange={(e) => setTwoFactorStatus(e.target.value)}>
                <FormControlLabel value="active" control={<Radio color="success" />} label="Active" />
                <FormControlLabel value="inactive" control={<Radio color="error" />} label="Inactive" />
              </RadioGroup>
            </FormControl>
            <FormControl sx={{ mb: 2 }} fullWidth>
              <FormLabel htmlFor="two-factor">API Key</FormLabel>
              <TextField id="two-factor" name="two-factor" value={twoFactorApiKey} onChange={(e) => setTwoFactorApiKey(e.target.value)} variant="outlined" margin="normal" />
            </FormControl>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button variant="contained" color="success" onClick={handleSave}>
                Save
              </Button>
            </Box>
          </Box>

          <Box border={1} borderRadius={2} p={3}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              MSG91 SMS
            </Typography>
            <Typography variant="body2"  sx={{
        mb: 2,
        color: 'success.main',
        display: 'inline-block', 
        
      }}>
              NB: Keep an OTP variable in your SMS provider's OTP template.
            </Typography>
            <FormControl component="fieldset" sx={{ mb: 2 }}>
              <RadioGroup row value={msgStatus} onChange={(e) => setMsgStatus(e.target.value)}>
                <FormControlLabel value="active" control={<Radio color="success" />} label="Active" />
                <FormControlLabel value="inactive" control={<Radio color="error" />} label="Inactive" />
              </RadioGroup>
            </FormControl>
            <FormControl sx={{ mb: 2 }} fullWidth>
              <FormLabel htmlFor="msgid">Template ID</FormLabel>
              <TextField id="msgid" name="msgid" value={msgTemplateId} onChange={(e) => setMsgTemplateId(e.target.value)} variant="outlined" placeholder="Ex:Acbbmrftgyhjklasdfghjkl" margin="normal" />
            </FormControl>
            <FormControl sx={{ mb: 2 }} fullWidth>
              <FormLabel htmlFor="msg-auth-key">Auth Key</FormLabel>
              <TextField id="msg-auth-key" name="msg-auth-key" value={msgAuthKey} onChange={(e) => setMsgAuthKey(e.target.value)} variant="outlined" placeholder="Ex:Acbbmrftgyhjklasdfghjkl" margin="normal" />
            </FormControl>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button variant="contained" color="success" onClick={handleSave}>
                Save
              </Button>
            </Box>
          </Box>
        </Stack>
      </Box>
    </div>
  )
}

export default SmsConfig
